module.exports = __webpack_public_path__ + "img/18.d40687dd.jpg";